module.exports = __webpack_public_path__ + "img/radio.3d6241cf.png";